import React from 'react';

const Features = ({}) => (
  <div className="section is-medium gradient-circle">
       <div className="container">
           <div id="test" className="section-title-wrapper has-text-centered">
               <div className="special-divider">
                   <span></span>
                   <span></span>
               </div>
               <h2 className="title is-2">Kurumsal Sistemler Bizim İşimiz.</h2>
               <h4 className="subtitle is-4">Dijital dönüşümünde, sizin için en doğru çözümleri sunuyoruz.</h4>
           </div>

           <div className="content-wrapper">
               <div className="columns is-vcentered">
                   <div className="column is-12">
                       <div className="columns is-multiline has-text-centered">
                         <div className="column is-4">
                             <div className="square-icon-box rounded secondary">
                                 <div className="icon-box-wrapper">
                                     <div className="icon-box">
                                         <i className="material-icons">bubble_chart</i>
                                     </div>
                                 </div>
                                 <div className="box-title">
                                     CRM - Müşteri İlişkileri Yönetimi
                                 </div>
                                 <div className="box-text">
                                     Fırsattan sözleşmeye tüm müşterileri ilişkilerinizi, canlı takip edin.
                                 </div>
                             </div>
                         </div>
                           <div className="column is-4">
                               <div className="square-icon-box rounded primary">
                                   <div className="icon-box-wrapper">
                                       <div className="icon-box">
                                           <i className="material-icons">dashboard</i>
                                       </div>
                                   </div>
                                   <div className="box-title">
                                       ERP - Kurumsal Kaynak Planlama
                                   </div>
                                   <div className="box-text">
                                       Şirketinize ait tüm iş süreçlerinizi merkezi bir sistemde takip edin.
                                   </div>
                               </div>
                           </div>
                           <div className="column is-4">
                               <div className="square-icon-box rounded secondary">
                                   <div className="icon-box-wrapper">
                                       <div className="icon-box">
                                           <i className="material-icons">insert_drive_file</i>
                                       </div>
                                   </div>
                                   <div className="box-title">
                                       MES - Üretim Otomasyonu
                                   </div>
                                   <div className="box-text">
                                       Canlı operatör, makine ve kamera verileri ile fabrikanızı 7/24 izleyin.
                                   </div>
                               </div>
                           </div>
                           <div className="column is-4">
                               <div className="square-icon-box rounded secondary">
                                   <div className="icon-box-wrapper">
                                       <div className="icon-box">
                                           <i className="material-icons">layers</i>
                                       </div>
                                   </div>
                                   <div className="box-title">
                                       Lokasyon Takip Sistemi
                                   </div>
                                   <div className="box-text">
                                       Akıllı lokasyon takibi ile iş güvenliğinizi artırın, puantaj takibini otomasyona bağlayın.
                                   </div>
                               </div>
                           </div>
                           <div className="column is-4">
                               <div className="square-icon-box rounded secondary">
                                   <div className="icon-box-wrapper">
                                       <div className="icon-box">
                                           <i className="material-icons">assessment</i>
                                       </div>
                                   </div>
                                   <div className="box-title">
                                       Mobil Çözümler
                                   </div>
                                   <div className="box-text">
                                       Sistemlerinizi mobil platforma bağlayarak iş verimliliğinizi artırın.
                                   </div>
                               </div>
                           </div>
                           <div className="column is-4">
                               <div className="square-icon-box rounded secondary">
                                   <div className="icon-box-wrapper">
                                       <div className="icon-box">
                                           <i className="material-icons">monetization_on</i>
                                       </div>
                                   </div>
                                   <div className="box-title">
                                       HRM - İnsan Kaynakları Yönetimi
                                   </div>
                                   <div className="box-text">
                                       İşe alımdan kariyer yönetimine kadar tüm insan kaynakları süreçlerinizi tek çatı altında toplayın.
                                   </div>
                               </div>
                           </div>
                           <div className="column is-4">
                           </div>
                           <div className="column is-4">
                               <div className="square-icon-box rounded primary">
                                   <div className="icon-box-wrapper">
                                       <div className="icon-box">
                                           <i className="material-icons">monetization_on</i>
                                       </div>
                                   </div>
                                   <div className="box-title">
                                       Özel Çözümler
                                   </div>
                                   <div className="box-text">
                                       İşinize özel ihtiyaçları bizimle paylaşın, birlikte çözüm üretelim.
                                   </div>
                               </div>
                           </div>
                       </div>
                   </div>
               </div>

               <div className="cta-wrapper has-text-centered is-title-reveal">
                   <h4 className="subtitle is-5">Kurumsal sisteminizdeki ihtiyaçlarınız için</h4>
                   <a href="#contact" type="button" className="button button-cta is-bold btn-align primary-btn raised">
                       Bize Ulaşın
                   </a>
               </div>
           </div>
       </div>
   </div>
);

export default Features;
